import config from 'config/config'
import React from 'react'
import { Input, Table } from 'semantic-ui-react'

export default class CompareField extends React.Component {
  render() {
    const { fieldName, oldValue, newValue } = this.props
    let labelInfo = {
      icon: 'asterisk',
      color: config.semantic_ui.primary_color,
    }

    // TODO: @Andreas - weed out null values
    const newValueNormalized = newValue === null ? '' : newValue
    const oldValueNormalized = oldValue === null ? '' : oldValue

    return (
      <Table.Row>
        <Table.Cell>{fieldName}</Table.Cell>
        <Table.Cell>
          <Input disabled fluid value={oldValueNormalized} />
        </Table.Cell>
        <Table.Cell>
          <Input
            label={
              oldValueNormalized !== newValueNormalized ? labelInfo : false
            }
            labelPosition="right corner"
            readOnly
            fluid
            value={newValueNormalized}
          />
        </Table.Cell>
      </Table.Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/Users/Segment/CompareField.jsx